const PICTURE_ROOT_DIR = "/assets/items-app/";


export function getPicturePathSmallImage(category, company, item) {
    let fullFilenamePath = PICTURE_ROOT_DIR + normalizeName(category) + '/' + normalizeName(company) + "/small/" + normalizeName(item) + "_small.jpg";
    return fullFilenamePath;
}

export function getPicturePathLargeImage(category, company, item) {
    let fullFilenamePath = PICTURE_ROOT_DIR + normalizeName(category) + '/' + normalizeName(company) + "/" + normalizeName(item) + ".jpg";
    return fullFilenamePath;
}

function normalizeName(name) {
    if (name) {
        name = ("" + name).replace(/[&\/\\#,+()$~%'":*?<>{}]/g, ' ');
        return name;
    } else {
        return null;
    }
}

export function normalizeForSearch(name) {
    if (name) {
        name = removeAllSpecialCharacters(name);
        if (name) {
            return name.toLowerCase();
        } else {
            return null;
        }
    } else {
        return null;
    }
}

export function removeAllSpecialCharacters(name) {
    if (name) {
        name = name.replace(/[^a-zA-Z0-9]/g, "")
        return name;
    } else {
        return null;
    }
}